import { render } from "./WhatsNewModal.vue?vue&type=template&id=32d41d48&scoped=true"
import script from "./WhatsNewModal.vue?vue&type=script&lang=js"
export * from "./WhatsNewModal.vue?vue&type=script&lang=js"

import "./WhatsNewModal.vue?vue&type=style&index=0&id=32d41d48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d41d48"]])

export default __exports__